<template>
  <div class="flex gap-0 md:gap-1">
    <span v-copy="copy">
      <slot />
    </span>
    <duplicate-icon
      v-if="copy && type === 'icon'"
      v-copy="copy"
      class="w-[16px] h-[16px] text-primary-600 hover:text-primary-800 cursor-pointer"
    />
  </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import { DuplicateIcon } from '@heroicons/vue/outline';

  defineProps({
    copy: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'icon',
    },
  });
</script>
